const Icon = (props: any) => {
    return (
        <svg width={19} height={16} viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M16.444 1H5.556C4.696 1 4 1.696 4 2.556v10.888C4 14.304 4.696 15 5.556 15h10.888c.86 0 1.556-.697 1.556-1.556V2.556C18 1.696 17.303 1 16.444 1zM3.667 2H1.333C1.15 2 1 2.597 1 3.333v9.334c0 .736.15 1.333.333 1.333h2.334"
                stroke="currentColor"
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M11 5v6M14 8H8" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" />
        </svg>
    );
};

export default Icon;
